import { getPaymentsUrl } from '@/services/tools/getPaymentsUrl';
import { getConfigStore } from '@/store/config/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ActivateBillingDialogBody } from './components/ActivateBillingDialogBody';

export const useActiveBillingDialog = () => {
    const { t } = useTranslation();
    const { isStandalone, bootedAsChild } = useSelector(getConfigStore);

    const getConfig = () => ({
        body: <ActivateBillingDialogBody />,
        title: t('activatebillingplan'),
        confirmLabel: t('activate'),
        cancelLabel: t('cancel'),
        onClickConfirm: (): void => {
            window.location.replace(getPaymentsUrl(isStandalone || bootedAsChild));
        },
        fullScreen: false,
    });

    return { getConfig };
};
